module.exports = __webpack_public_path__ + "ddf4eb8ca117b2047b58c5655d8572ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/low_5.jpg
// module id = 1748
// module chunks = 5